import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズの Products ロゴアイコン
 */
export function ProductLogoMediumProducts({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 672 672" fill="none" {...props}>
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path d="M136.301 244.005C136.301 239.576 140.725 236.51 144.871 238.066L308.417 299.441C315.016 301.918 319.388 308.228 319.388 315.276V523.151C319.387 527.58 314.964 530.645 310.817 529.089L158.242 471.831C145.044 466.878 136.301 454.259 136.301 440.162V244.005Z" fill="white" />
      <path d="M527.728 238.066C531.874 236.51 536.298 239.576 536.298 244.005V440.162C536.298 454.259 527.555 466.878 514.357 471.831L361.781 529.089C357.635 530.644 353.211 527.58 353.211 523.151V315.276C353.211 308.228 357.583 301.918 364.182 299.441L527.728 238.066Z" fill="white" />
      <path d="M324.412 138.157C332.074 135.282 340.519 135.281 348.182 138.157L509.054 198.528C514.539 200.587 514.539 208.345 509.054 210.404L342.239 273.007C338.408 274.444 334.186 274.444 330.354 273.007L163.54 210.404C158.055 208.346 158.055 200.587 163.54 198.528L324.412 138.157Z" fill="#57D7D9" />
    </svg>;
}